/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import parse from 'html-react-parser'
import { Typography } from '@material-ui/core'

const styles = theme => ({
    headerWrapper: {
        marginTop: -16
    },
    title: {
        margin: 0,
        paddingTop: theme.title.paddingTop - 8 + 'px!important',
        paddingBottom: theme.title.paddingBottom - 8 + 'px!important',
        textTransform: theme.title.textTransform,
        ...(!theme.isMobile && {
            paddingTop: theme.title.paddingTop + 'px!important',
            paddingBottom: theme.title.paddingBottom + 'px!important'
        }),
        color: theme.header.color + '!important',
        //textTransform: 'uppercase',
        textShadow: 'none!important'
    },
    emptyTitle: {
        paddingTop: '0!important',
        paddingBottom: '20px!important'
    },
    description: {
        paddingTop: 0,
        paddingBottom: 0,
        color: theme.description.color + '!important',
        marginBottom: theme.description.marginBottom,
        textAlign: theme.description.textAlign + '!important',
        ...(!theme.isMobile && {
            paddingBottom: theme.spacing(1),
            marginBottom: theme.description.marginBottom
        }),
        fontSize: '0.98rem',
        ...(theme.descriptionStyle === 'hidden' && {
            visibility: 'hidden',
            height: 0,
            marginBottom: theme.spacing(1),
        })
    },
    emptyDescription: {
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.description.emptyMarginBottom
    }
})

class QuestionPageHeader extends PureComponent {
    render() {
        const { questionPage, classes } = this.props
        return (
            <div className={classes.headerWrapper + ' questionPageHeader'}>
                <Typography
                    component="h4"
                    variant={questionPage.titleSize}
                    align="center"
                    className={classes.title + ' ' + (!questionPage.title ? classes.emptyTitle : '')}
                >
                    {questionPage.title}
                </Typography>
                {questionPage.description && (
                    <Typography variant="body1" align="center" color="textSecondary" className={classes.description}>
                        {parse(questionPage.description)}
                    </Typography>
                )}
                {!questionPage.description && (
                    <Typography variant="body1" align="center" color="textSecondary" className={classes.emptyDescription} />
                )}
            </div>
        )
    }
}

export default withStyles(styles)(QuestionPageHeader)
